import React from "react";
import type { SectionComponentProps } from "../../registry.js";
import { logConversionEvent } from "@repo/backend/firebase/analytics";

interface HoursDay {
  day: string;
  hours: string;
}

interface HoursSimpleProps {
  headline?: string;
  hours?: HoursDay[];
  phone?: string;
  address?: string;
}

const DEFAULT_HOURS: HoursDay[] = [
  { day: "Monday", hours: "Closed" },
  { day: "Tuesday – Thursday", hours: "5:00 PM – 10:00 PM" },
  { day: "Friday – Saturday", hours: "5:00 PM – 11:00 PM" },
  { day: "Sunday", hours: "4:00 PM – 9:00 PM" },
];

export function HoursSimple({ props }: SectionComponentProps) {
  const {
    headline = "Hours & Location",
    hours = DEFAULT_HOURS,
    phone,
    address,
  } = props as HoursSimpleProps;

  return (
    <section className="py-16 px-6 bg-background" id="hours">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-10">{headline}</h2>
        <div className="space-y-3 mb-8">
          {hours.map((row, i) => (
            <div
              key={i}
              data-stagger-child
              className="flex justify-between items-center text-sm py-2 border-b border-border last:border-0"
            >
              <span className="text-foreground font-medium">{row.day}</span>
              <span className="text-muted-foreground">{row.hours}</span>
            </div>
          ))}
        </div>
        {(phone || address) && (
          <div className="text-sm text-muted-foreground space-y-1 pt-4">
            {address && <p>{address}</p>}
            {phone && (
              <p>
                <a href={`tel:${phone}`} onClick={() => logConversionEvent("click_call", { phone })} className="text-primary hover:underline">
                  {phone}
                </a>
              </p>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
